import { Container, Typography, Box } from '@mui/material';

// Shared shape for all legal/footer pages, modeled on
// references/ProdWebsite/frontend/src/pages/legal/*.js (Container + Typography blocks).
export default function LegalPage({ title, children }) {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
      <Typography variant="h2" sx={{ mb: 4 }}>
        {title}
      </Typography>
      <Box sx={{ '& > *': { mb: 3 } }}>{children}</Box>
    </Container>
  );
}
